import { render } from "./TwitterTimeline.vue?vue&type=template&id=309944a1&scoped=true"
import script from "./TwitterTimeline.vue?vue&type=script&lang=js"
export * from "./TwitterTimeline.vue?vue&type=script&lang=js"

import "./TwitterTimeline.vue?vue&type=style&index=0&id=309944a1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-309944a1"]])

export default __exports__